<template>
  <div class="p-topic">
    <div class="p-topic__banner">
      <div ref="bannerDom" class="p-topic__banner-carousel">
        <span class="mask">
          <img src="https://static.ctwant.com/images/dist/braceHeight.png" alt="撐高度用">
        </span>
        <span class="dots" />
        <transition-group
          tag="div"
          name="fade"
          class="carousels"
        >
          <div
            v-for="(item, index) in datas.covers"
            v-show="bannerActive === index"
            :key="item.lg"
            :style="{backgroundImage: `url(${item.lg})`}"
            :class="{
              bannerCyclingA: ((index + 1) % 4 === 1 && !isLaptop && datas.covers.length > 1),
              bannerCyclingB: ((index + 1) % 4 === 2 && !isLaptop && datas.covers.length > 1),
              bannerCyclingC: ((index + 1) % 4 === 3 && !isLaptop && datas.covers.length > 1),
              bannerCyclingD: ((index + 1) % 4 === 0 && !isLaptop && datas.covers.length > 1)
            }"
            class="bannerPic"
          />
        </transition-group>
        <div v-if="!isLaptop" class="scroll-arrow">
          <span>scroll</span>
        </div>
      </div>
      <div ref="titleArea" class="p-topic__banner-title container">
        <div>
          <h1>{{ datas.title }}</h1>
          <p v-show="datas.description">
            {{ datas.description }}
          </p>
          <!-- Tags -->
          <div class="topic__tags">
            <nuxt-link
              v-for="(tag, idx) in datas.hot_tags"
              :key="idx"
              :to="`/search/${tag}/`"
            >
              {{ tag }}
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>

    <div v-if="series_article.items.length > 0" class="p-topic__body">
      <div class="container">
        <div class="p-topic__article">
          <div class="p-topic__article-featured">
            <!-- <img src="https://static.ctwant.com/images/dist/topic_featured_icon.svg" alt="精選文章圖示"> -->
            <h2>編輯精選</h2>
            <p>CTWANT 編輯們的精選文章</p>
          </div>
          <div class="p-topic__article-list">
            <div
              v-for="item in series_article.items"
              :key="item.id"
              class="p-topic__article-item"
            >
              <a
                :href="`/article/${item.id}/`"
                target="_blank"
                rel="noreferrer noopener"
                title="另開視窗連結新聞頁"
              >
                <LazyImage class="cover" width="100%" :src="item.cover" :alt="item.caption" />
                <div>
                  <h3 class="m-card--mle-2">
                    {{ item.title }}
                  </h3>
                  <div>
                    <!-- <span v-if="isMobile === false || index === 0">
                      {{ item.participants.author || item.participants.editor || item.participants.reporter }}
                    </span> -->
                    <time :datetime="item.publish_at">
                      {{ item.publish_at }}
                    </time>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div
            v-if="series_article.last_page > 0"
            v-show="series_article.current_page < series_article.last_page"
            class="p-topic__article-more"
          >
            <button
              v-show="isSeriesLoading === false"
              :disabled="series_article.current_page >= series_article.last_page"
              type="button"
              title="看更多新聞項目"
              @click="moreSeries('article')"
            >
              點擊看更多
              <span>
                <img src="https://static.ctwant.com/images/dist/click_icon.svg" alt="查看更多 點擊圖示">
                <img src="https://static.ctwant.com/images/dist/expand_icon1.svg" alt="查看更多 展開圖示">
              </span>
            </button>
            <img v-show="isSeriesLoading === true" src="https://static.ctwant.com/images/dist/loading_gray.gif" alt="載入中圖示">
          </div>
        </div>
      </div>
    </div>

    <div v-if="series_video.items.length > 0" class="p-topic__body video">
      <div class="container">
        <div class="p-topic__video">
          <div class="p-topic__video-featured">
            <!-- <img src="https://static.ctwant.com/images/dist/topic_play_icon.svg" alt="精選影音圖示"> -->
            <h2>精選影音</h2>
            <p>CTWANT 編輯們的精選影音</p>
          </div>
          <div class="p-topic__video-list">
            <div
              v-for="item in series_video.items"
              :key="item.id"
              class="p-topic__video-item"
            >
              <a :href="`/video/${item.id}/`" target="_blank" rel="noreferrer noopener" title="另開視窗連結影音新聞頁">
                <div class="photo">
                  <img class="mask" src="https://static.ctwant.com/images/dist/topic_video_item_mask.png" alt="新聞封面上的美化遮罩">
                  <LazyImage class="cover" width="100%" :src="item.cover" :alt="item.caption" />
                  <div data-v-272f38cf="" class="icon-wrapper">
                    <div data-v-272f38cf="" class="icon" />
                  </div>
                </div>
                <div class="content">
                  <h3 class="m-card--mle-2">
                    {{ item.title }}
                  </h3>
                  <div>
                    <!-- <span v-if="isMobile === false || index === 0">
                      {{ item.participants.author || item.participants.editor || item.participants.reporter }}
                    </span> -->
                    <time :datetime="item.publish_at">
                      {{ item.publish_at }}
                    </time>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div
            v-if="series_video.last_page > 0"
            v-show="series_video.current_page < series_video.last_page"
            class="p-topic__video-more"
          >
            <button
              v-show="isSeriesLoading === false"
              :disabled="series_video.current_page >= series_video.last_page"
              type="button"
              title="看更多影音新聞項目"
              @click="moreSeries('video')"
            >
              點擊看更多
              <span>
                <img src="https://static.ctwant.com/images/dist/click_icon.svg" alt="查看更多 點擊圖示">
                <img src="https://static.ctwant.com/images/dist/expand_icon1.svg" alt="查看更多 展開圖示">
              </span>
            </button>
            <img v-show="isSeriesLoading === true" src="https://static.ctwant.com/images/dist/loading_gray.gif" alt="載入中圖示">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LazyImage from '@/components/LazyImage.vue'

export default {
  components: {
    LazyImage
  },
  validate({ params, redirect }) {
    if (/^\d+$/.test(params.id) === false) {
      redirect(301, '/')
    }
    return /^\d+$/.test(params.id)
  },
  async asyncData({ $axios, params, query, error }) {
    const api = $axios.defaults.baseURL
    const url = `${api}/topic/${params.id}`
    const seriesArticleUrl = `${api}/topic/${params.id}/articles?page=1`
    const seriesVideoUrl = `${api}/topic/${params.id}/videos?page=1`
    try {
      if (!params.id.match(/^\d+$/)) {
        throw new TypeError('error format topic id', params.id)
      }
      const { data } = await $axios.$get(url)
      const { data: seriesArticleData } = await $axios.$get(seriesArticleUrl)
      const { data: seriesVideoData } = await $axios.$get(seriesVideoUrl)
      return {
        datas: data,
        series_article: {
          current_page: 0,
          last_page: seriesArticleData.last_page,
          items: data.articles
        },
        series_video: {
          current_page: 0,
          last_page: seriesVideoData.last_page,
          items: data.videos
        }
      }
    } catch (e) {
      if (e instanceof TypeError) {
        console.error('Topic', {
          code: 400,
          message: e.message
        })
        error({ statusCode: 400 })
      } else {
        console.error('Topic', {
          code: e.response.data.code,
          message: e.response.data.message,
          method: e.response.config.method,
          url: e.response.config.url
        })
        error({ statusCode: 404 })
      }
    }
  },
  data() {
    return {
      main_category: '專題',
      datas: null,
      series_article: null,
      series_video: null,
      bannerActive: 0,
      timer: null,
      isSeriesLoading: false
    }
  },
  head() {
    const hostAndNeedBackslashPath = this.HOST + (this.$route.path.substr(this.$route.path.length - 1) === '/' ? this.$route.path : `${this.$route.path}/`)
    const headData = {
      title: `${this.datas.title} | 專題報導 | CTWANT`,
      description: this.datas.description ? this.datas.description.replace(/<[^>]+>|&[^>]+;/g, '').trim().substr(0, 100) : `關於「${this.datas.title}」的整合報導。`
    }
    const article1PublishAtTimeZone = this.series_article.items.length > 0 ? this.series_article.items[0].publish_at_time_zone ? this.series_article.items[0].publish_at_time_zone : this.series_video.items[0].publish_at_time_zone ? this.series_video.items[0].publish_at_time_zone : null : null
    const websiteCategory = {
      '@context': 'http://schema.org',
      '@type': 'Website',
      author: {
        '@type': 'Person',
        name: 'CTWANT'
      },
      creator: {
        '@type': 'Person',
        name: 'CTWANT'
      },
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': hostAndNeedBackslashPath
      },
      publisher: {
        '@type': 'Organization',
        name: 'CTWANT',
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.ctwant.com/images/dist/logo.png'
        }
      },
      headline: headData.title,
      name: headData.title,
      url: hostAndNeedBackslashPath,
      dateCreated: this.datas.created_at_time_zone,
      datePublished: this.datas.created_at_time_zone
    }
    if (article1PublishAtTimeZone) {
      websiteCategory.dateModified = article1PublishAtTimeZone
    }
    const articleItemListCategory = {
      '@context': 'http://schema.org',
      '@type': 'ItemList',
      itemListElement: this.series_article.items.map((item, index) => {
        return {
          '@type': 'ListItem',
          position: index + 1,
          name: item.title,
          image: item.cover,
          url: `${this.HOST}/article/${item.id}`
        }
      }).slice(0, 5)
    }
    const videoItemListCategory = {
      '@context': 'http://schema.org',
      '@type': 'ItemList',
      itemListElement: this.series_video.items.map((item, index) => {
        return {
          '@type': 'ListItem',
          position: index + 1,
          name: item.title,
          image: item.cover,
          url: `${this.HOST}/video/${item.id}`
        }
      }).slice(0, 5)
    }
    const BreadcrumbList = {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@id': this.HOST,
            name: 'CTWANT'
          }
        },
        {
          '@type': 'ListItem',
          position: 2,
          item: {
            '@id': `${this.HOST}/topic/`,
            name: '專題報導'
          }
        },
        {
          '@type': 'ListItem',
          position: 3,
          item: {
            '@id': hostAndNeedBackslashPath,
            name: headData.title
          }
        }
      ]
    }
    return {
      title: headData.title,
      meta: [
        { hid: 'description', name: 'description', content: headData.description },
        { hid: 'ogUrl', property: 'og:url', content: hostAndNeedBackslashPath },
        { hid: 'ogType', property: 'og:type', content: 'website' },
        { hid: 'ogTitle', property: 'og:title', content: headData.title },
        { hid: 'ogDescription', property: 'og:description', content: headData.description },
        { hid: 'max-image-preview', name: 'robots', content: (this.datas.covers[0].lg) ? 'max-image-preview:large' : 'max-image-preview:standard' },
        { hid: 'ogImage', property: 'og:image', content: this.datas.covers[0].lg ? this.datas.covers[0].lg : this.datas.covers[0].md },
        { hid: 'ogImageWidth', property: 'og:image:width', content: this.datas.covers[0].lg ? '1856' : '858' },
        { hid: 'ogImageHeight', property: 'og:image:height', content: this.datas.covers[0].lg ? '838' : '388' },
        { hid: 'topicPublished_time', name: 'pubdate', property: 'topic:published_time', itemprop: 'datePublished', content: this.datas.created_at_time_zone },
        { hid: 'topicModified_time', name: 'lastmod', property: 'topic:modified_time', itemprop: 'dateModified', content: article1PublishAtTimeZone }
      ],
      link: [
        { hid: 'alternate', rel: 'alternate', hreflang: 'zh-Hant', href: hostAndNeedBackslashPath },
        { hid: 'canonical', rel: 'canonical', href: hostAndNeedBackslashPath },
        { rel: 'dns-prefetch', href: '//connect.facebook.net' },
        { rel: 'dns-prefetch', href: '//www.instagram.com' },
        { rel: 'dns-prefetch', href: '//api.instagram.com' }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        { innerHTML: JSON.stringify(websiteCategory), type: 'application/ld+json' },
        { innerHTML: JSON.stringify(articleItemListCategory.itemListElement.length > 0 ? articleItemListCategory : videoItemListCategory), type: 'application/ld+json' },
        { innerHTML: JSON.stringify(BreadcrumbList), type: 'application/ld+json' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'HOST',
      'isLaptop'
      // 'isMobile'
    ])
  },
  created() {
    if (this.datas !== null && this.datas.covers.length > 0) {
      this.setHandler()
    }
  },
  mounted() {
    const vm = this
    this.$nextTick(() => {
      // this.$store.dispatch('ad/displayAd')
      this.$store.dispatch('ad/registerAndDisplayPopupAd', { type: this.main_category })
      vm.$gtm.push({
        event: 'domMounted',
        pageUrl: vm.$route.fullPath,
        pageTitle: this.datas.title,
        pageCategory: this.main_category
      })
    })
  },
  methods: {
    setHandler() {
      this.clearHandler()
      this.timer = setInterval(this.nextHandler, 5000)
    },
    nextHandler() {
      this.bannerActive = (this.bannerActive + 1) % this.datas.covers.length
    },
    clearHandler() {
      clearInterval(this.timer)
    },
    async moreSeries(type) {
      const api = this.$axios.defaults.baseURL
      let page = type === 'article' ? this.series_article.current_page : this.series_video.current_page
      page = page += 1
      const seriesUrl = `${api}/topic/${this.$route.params.id}/${type}s?page=${page}`

      try {
        this.isSeriesLoading = true
        const { data } = await this.$axios.$get(seriesUrl)
        if (type === 'article') {
          this.series_article.items = [...this.series_article.items, ...data.items]
          this.series_article.current_page = data.current_page
          this.series_article.last_page = data.last_page
        } else if (type === 'video') {
          this.series_video.items = [...this.series_video.items, ...data.items]
          this.series_video.current_page = data.current_page
          this.series_video.last_page = data.last_page
        }
        this.isSeriesLoading = false
      } catch (e) {
        this.isSeriesLoading = false
        console.error(`Error get series (${type}) data`, {
          code: e.response.data.code,
          message: e.response.data.message,
          method: e.response.config.method,
          url: e.response.config.url
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/pages/_topic';
</style>
